import { html } from 'rune-ts';
import klass from './Input_Stock.module.scss';
import { StockInputValue_New_NoOption } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import { Base_Input_Stock } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';
import { shareFont } from '@services/MarppleShop/shared/typography';

interface InputStock_New_NoOption extends InputEditor {
  mode: typeof MODE.NEW;
  stock_type: typeof StockType.TOTAL_STOCK;
  value: StockInputValue_New_NoOption[];
}

export class Input_Stock_New_NoOption extends Base_Input_Stock<InputStock_New_NoOption> {
  protected override inputTemplate() {
    return html`
      <div class="${klass.stock_table} ${klass.new_no_option} ${shareFont('14_medium')}">
        <div class="${klass.row} ${klass.header}">
          <div class="${klass.col}">재고</div>
        </div>
        ${this.data.value.map((item, index) => {
          return html`
            <div class="${klass.row}">
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.stock,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'stock');
                  },
                })}
              </div>
            </div>
          `;
        })}
      </div>
    `;
  }
}
